import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { getProficiency } from "../../../../../constants/resume";
import { buildLanguages, buildSkills } from '../../../../../services/pdfGeneratorService';

export default ({ backgroundColor,textColor,dateOfBirth, shouldShowHeader, shouldShowExperience, shouldShowEducation, shouldShowSkills, aboveTitleItems, data, getFontFamily, selectedFont, parseHtmlToText }) => {
    
    const styles = StyleSheet.create({
        page: {
            width: '100%',
            padding: 0,
            margin: 0,
            fontFamily: getFontFamily(selectedFont),
        },
        resumeHeader: {
            backgroundColor: backgroundColor !== 'white' ? backgroundColor : '#171717',
            color: 'white',
            padding: '20px 40px',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: 20,
        },
        headerLeft: {
            width: '30%',
        },
        headerRight: {
            width: '60%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
        },
        rightInnerSection: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginLeft: 35,
        },
        rightInnerSectionDark: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginLeft: 35,
        },
        aboveTitleItem: {
            fontSize: 9,
            color:  textColor !== 'black' ? textColor : 'white',
            marginBottom: 3,
        },
        aboveTitleItemDark: {
            fontSize: 9,
            color: '#808080',
            marginBottom: 3,
        },
        headerName: {
            fontSize: 18,
            fontWeight: 'bold',
            color:  textColor !== 'black' ? textColor : 'white',
            margin: 0,
            textTransform: 'none',
        },
        headerTitle: {
            fontSize: 14,
            color:  textColor !== 'black' ? textColor : 'white',
            margin: '4px 0 0 0',
            fontStyle: 'normal',
        },
        resumeSummary: {
            padding: '0 40px',
            marginBottom: 15,
        },
        summaryText: {
            margin: 0,
            fontSize: 10,
            textAlign: 'left',
            color: 'black',
        },
        resumeSection: {
            padding: '0 40px',
            marginBottom: 15,
            width: '100%',
        },
        sectionTitle: {
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'left',
            marginTop: 10,
            marginBottom: 10,
            textTransform: 'none',
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
            borderBottomStyle: 'solid',
            paddingBottom: 5,
        },
        experienceItem: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 10,
            width: '100%',
        },
        left: {
            width: '35%',
            fontSize: 10,
        },
        right: {
            width: '65%',
            textAlign: 'left',
        },
        preTitle: {
            fontSize: 10,
            fontWeight: 'bold',
            marginBottom: 2,
        },
        mainTitle: {
            fontSize: 10,
            fontWeight: 'bold',
            marginBottom: 2,
        },
        location: {
            fontSize: 9,
            color: '#666',
            marginBottom: 2,
        },
        dates: {
            fontSize: 9,
            color: '#666',
            marginBottom: 2,
        },
        description: {
            fontSize: 10,
            textAlign: 'left',
            color: 'black',
            lineHeight: 1.2,
        },
        skillItems: {
            fontSize: 10,
            textAlign: 'left',
            color: 'black',
        },
    });

    const getFriendlyMonth = month => {
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return monthNames[month - 1];
    };

    const buildAddress = (data) => {
        const parts = [];
        if (data.address) parts.push(data.address);
        if (data.city) parts.push(data.city);
        if (data.state) parts.push(data.state);
        if (data.zipCode) parts.push(data.zipCode);
        if (data.country) parts.push(data.country);
        return parts.join(', ');
    };



    const skillsAsText = buildSkills(data);
    const languagesAsText = buildLanguages(data);

    return (
        <>
            {shouldShowHeader && (
                <View style={styles.resumeHeader}>
                    <View style={styles.headerLeft}>
                        <Text style={styles.headerName}>{`${data.firstName || ''} ${data.lastName || ''}`.trim()}</Text>
                        {data.title && <Text style={styles.headerTitle}>{data.title}</Text>}
                    </View>
                    <View style={styles.headerRight}>
                        <View style={styles.rightInnerSection}>
                            <Text style={styles.aboveTitleItem}>{buildAddress(data)}</Text>
                            {data.phoneNumber && <Text style={styles.aboveTitleItem}>{data.phoneNumber}</Text>}
                            {data.email && <Text style={styles.aboveTitleItem}>{data.email}</Text>}
                        </View>
                        <View style={styles.rightInnerSectionDark}>
                            {dateOfBirth && <Text style={styles.aboveTitleItemDark}>{dateOfBirth}</Text>}
                            <Text style={styles.aboveTitleItemDark}>{data.nationality}</Text>
                            <Text style={styles.aboveTitleItemDark}>{data.driversLicense}</Text>
                        </View>
                    </View>
                </View>
            )}

            {data.summary && (
                <View style={styles.resumeSummary}>
                    {parseHtmlToText(data.summary, styles.summaryText)}
                </View>
            )}

            {shouldShowExperience && (
                <View style={styles.resumeSection}>
                    <Text style={styles.sectionTitle}>Employment History</Text>
                    {data.experience.map((job, idx) => (
                        <View style={styles.experienceItem} key={idx}>
                            <View style={styles.left}>
                                <Text style={styles.preTitle}>{job.jobPosition}</Text>
                                <Text style={styles.mainTitle}>{job.companyName}</Text>
                                {job.location && <Text style={styles.location}>{job.location}</Text>}
                                {(job.startDate?.month || job.startDate?.year) && (
                                    <Text style={styles.dates}>
                                        {getFriendlyMonth(job.startDate?.month)} {job.startDate?.year} - {job.isPresent ? 'Present' : `${getFriendlyMonth(job.endDate?.month)} ${job.endDate?.year || ''}`}
                                    </Text>
                                )}
                            </View>
                            <View style={styles.right}>
                                {job.description && (
                                    parseHtmlToText(job.description, styles.description)
                                )}
                            </View>
                        </View>
                    ))}
                </View>
            )}

            {shouldShowSkills && (
                <View style={styles.resumeSection}>
                    <Text style={styles.sectionTitle}>Skills</Text>
                    <Text style={styles.skillItems}>{skillsAsText}</Text>
                </View>
            )}
            {languagesAsText?.length > 0 && (
                <View style={styles.resumeSection}>
                    <Text style={styles.sectionTitle}>Languages</Text>
                    <Text style={styles.skillItems}>
                        {languagesAsText}
                    </Text>
                </View>
            )}

            {shouldShowEducation && (
                <View style={styles.resumeSection}>
                    <Text style={styles.sectionTitle}>Education</Text>
                    {data.education.map((ed, idx) => (
                        <View style={styles.experienceItem} key={idx}>
                            <View style={styles.left}>
                                <Text style={styles.preTitle}>{ed.degreeName} {ed.courseName && `(${ed.courseName})`}</Text>
                                <Text style={styles.mainTitle}>{ed.universityName}</Text>
                                {ed.location && <Text style={styles.location}>{ed.location}</Text>}
                                {(ed.startDate?.month || ed.startDate?.year) && (
                                    <Text style={styles.dates}>
                                        {getFriendlyMonth(ed.startDate?.month)} {ed.startDate?.year} - {getFriendlyMonth(ed.endDate?.month)} {ed.endDate?.year}
                                    </Text>
                                )}
                            </View>
                            <View style={styles.right}>
                                {ed.description && (
                                    parseHtmlToText(ed.description, styles.description)
                                )}
                            </View>
                        </View>
                    ))}
                </View>
            )}


        </>
    )
}
